module.exports = __webpack_public_path__ + "img/SCN-vibrating-wire-linear-digit-formula-12pt.ef365211.svg";